"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactInputAutosize = _interopRequireDefault(require("react-input-autosize"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _stringifyValue = _interopRequireDefault(require("./utils/stringifyValue"));
var _defaultArrowRenderer = _interopRequireDefault(require("./utils/defaultArrowRenderer"));
var _defaultFilterOptions = _interopRequireDefault(require("./utils/defaultFilterOptions"));
var _defaultMenuRenderer = _interopRequireDefault(require("./utils/defaultMenuRenderer"));
var _propsOrState = _interopRequireDefault(require("../../utils/propsOrState"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _Option = _interopRequireDefault(require("./components/Option"));
var _Value = _interopRequireDefault(require("./components/Value"));
var _Spinner2 = _interopRequireDefault(require("../Spinner"));
var _RenderInBody = _interopRequireDefault(require("../RenderInBody"));
var _excluded = ["inputClassName"];
var _Spinner;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Need turn on if you need this functionality
 * import Async from './Async';
 * import AsyncCreatable from './AsyncCreatable';
 * import Creatable from './Creatable';
 */

var instanceId = 1;
var defaultProps = {
  theme: {},
  arrowRenderer: _defaultArrowRenderer["default"],
  backspaceRemoves: true,
  backspaceToRemoveMessage: 'Press backspace to remove {label}',
  clearable: false,
  clearAllText: 'Clear all',
  clearValueText: 'Clear value',
  deleteRemoves: true,
  delimiter: ',',
  disabled: false,
  escapeClearsValue: true,
  filterOptions: _defaultFilterOptions["default"],
  id: '',
  ignoreAccents: true,
  ignoreCase: true,
  inputProps: {},
  autosize: true,
  autosizeMenu: false,
  isLoading: false,
  joinValues: false,
  labelKey: 'label',
  matchPos: 'any',
  matchProp: 'any',
  menuBuffer: 0,
  menuRenderer: _defaultMenuRenderer["default"],
  multi: false,
  noResultsText: 'No results found',
  onBlurResetsInput: true,
  onCloseResetsInput: true,
  openAfterFocus: false,
  optionComponent: _Option["default"],
  optionsListEnforced: true,
  pageSize: 5,
  placeholder: 'Select...',
  scrollMenuIntoView: true,
  searchable: true,
  tabSelectsValue: true,
  valueComponent: _Value["default"],
  valueKey: 'value',
  isDirty: false,
  validateOn: 'change',
  renderInBody: true
};

/**
 * Used for displaying custom Select control component.
 */
var Select = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Select, _React$Component);
  function Select(_props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Select);
    _this = _callSuper(this, Select, [_props]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onResizeListener", function () {
      _this.setMenuPosition();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onScrollListener", function () {
      _this.setMenuPosition();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleTouchOutsideEvent", function (enabled) {
      // eslint-disable-line
      if (enabled) {
        document.addEventListener('touchstart', _this.handleTouchOutside);
      } else {
        document.removeEventListener('touchstart', _this.handleTouchOutside);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchOutside", function (event) {
      // handle touch outside on ios to dismiss menu
      // check wrapper exists and wrapper not contain event.target
      // and if no menuContainer or menuContainer not contain event.target
      // https://www.mulesoft.org/jira/browse/UIFX-651
      if (_this.wrapper && !_this.wrapper.contains(event.target) && (!_this.menuContainer || !_this.menuContainer.contains(event.target))) {
        _this.closeMenu();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focus", function () {
      if (!_this.input) return;
      _this.input.focus();
      if (_this.props.openAfterFocus) {
        _this.setState({
          isOpen: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "blurInput", function () {
      if (!_this.input) return;
      _this.input.blur();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchMove", function () {
      // Set a flag that the view is being dragged
      _this.dragging = true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchStart", function () {
      // Set a flag that the view is not being dragged
      _this.dragging = false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchEnd", function (event) {
      // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)
      if (_this.dragging) return;

      // Fire the mouse events
      _this.handleMouseDown(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchEndClearValue", function (event) {
      // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)
      if (_this.dragging) return;

      // Clear the value
      _this.clearValue(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseDown", function (event) {
      // if the event was triggered by a mousedown and not the primary
      // button, or if the component is disabled, ignore it.
      if (_this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
        return false;
      }
      if (event.target.tagName === 'INPUT') {
        return false;
      }

      // prevent default event handlers
      event.stopPropagation();
      event.preventDefault();
      // for the non-searchable select, toggle the menu
      if (!_this.props.searchable) {
        _this.focus();
        return _this.setState({
          isOpen: !_this.state.isOpen
        });
      }
      if (_this.state.isFocused) {
        // On iOS, we can get into a state where we think the input is focused but it isn't really,
        // since iOS ignores programmatic calls to input.focus()
        // that weren't triggered by a click event.
        // Call focus() again here to be safe.
        _this.focus();
        var input = _this.getInput();

        // clears the value so that the cursor will be at the end
        // of input when the component re-renders
        input.value = '';

        // if the input is focused, ensure the menu is open
        _this.setState({
          isOpen: true,
          isPseudoFocused: false
        });
      } else {
        // otherwise, focus the input and open the menu
        _this.openAfterFocus = true;
        _this.focus();
      }
      return false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseDownOnArrow", function (event) {
      // if the event was triggered by a mousedown and not the primary
      // button, or if the component is disabled, ignore it.
      if (_this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      // If the menu isn't open, let the event bubble to the main handleMouseDown
      if (!_this.state.isOpen) {
        return;
      }
      // prevent default event handlers
      event.stopPropagation();
      event.preventDefault();
      // close the menu
      _this.closeMenu();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseDownOnMenu", function (event) {
      // if the event was triggered by a mousedown and not the primary
      // button, or if the component is disabled, ignore it.
      if (_this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.openAfterFocus = true;
      _this.focus();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeMenu", function () {
      var value = _this.props.onCloseResetsInput ? '' : _this.state.inputValue;
      _this.setState({
        isOpen: false,
        isPseudoFocused: _this.state.isFocused && !_this.props.multi,
        inputValue: value
      });
      _this.hasScrolledToOption = false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createCustomOption", function (value) {
      var _this$props = _this.props,
        labelKey = _this$props.labelKey,
        valueKey = _this$props.valueKey;
      return (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, labelKey, value), valueKey, value), "isCustom", true);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setCustomOption", function (value) {
      var _this$props2 = _this.props,
        valueKey = _this$props2.valueKey,
        multi = _this$props2.multi;
      var customOptions = _this.state.customOptions;
      _this.setState({
        isOpen: multi,
        inputValue: ''
      });
      var valueArray = _this.getValueArray(_this.state.value);
      if (valueArray.some(function (entry) {
        return entry[valueKey] === value;
      })) {
        return;
      }
      var newCustomOption = _this.createCustomOption(value);
      _this.setState({
        customOptions: multi ? customOptions.concat(newCustomOption) : [newCustomOption]
      });
      if (!multi) {
        _this.setValue(newCustomOption);
        _this.blurInput();
      } else {
        _this.addValue(newCustomOption);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleInputFocus", function (event) {
      if (_this.props.disabled) return;
      var isOpen = _this.propsOrState('isOpen') || _this.openAfterFocus || _this.props.openOnFocus;
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        isFocused: true,
        isOpen: isOpen
      });
      _this.openAfterFocus = false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleGlobalMouseDown", function (event) {
      var input = _this.getInput();
      var isTargetInInput = input && input.contains(event.target);
      var isTargetInMenu = _this.menuContainer && _this.menuContainer.contains(event.target);
      var isTargetInControl = _this.control && _this.control.contains(event.target);
      if (!(isTargetInInput || isTargetInMenu || isTargetInControl)) {
        var onBlurredState = {
          isFocused: false,
          isOpen: false,
          isPseudoFocused: false
        };
        if (_this.props.onBlurResetsInput) {
          onBlurredState.inputValue = '';
        }
        _this.setState(onBlurredState);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleInputChange", function (event) {
      var newInputValue = _this.props.autosize ? event.target.value : event.value;
      if (_this.state.inputValue !== newInputValue && _this.props.onInputChange) {
        var nextState = _this.props.onInputChange(newInputValue);
        // Note: != used deliberately here to catch undefined and null
        if ((0, _typeof2["default"])(nextState) !== 'object' && nextState != null) {
          newInputValue = "".concat(nextState);
        }
      }
      _this.setState({
        isOpen: true,
        isPseudoFocused: false,
        inputValue: newInputValue
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFocus", function () {
      // Do not focus when the Select is not searchable (editable).
      if (!_this.props.searchable) {
        return;
      }

      // If it's not open, open it
      if (!_this.state.isOpen) {
        _this.setState({
          isOpen: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (event) {
      // Do not continue if the component is disabled.
      if (_this.props.disabled) return;

      // Do not continue if the event was already handled.
      if (typeof _this.props.onInputKeyDown === 'function') {
        _this.props.onInputKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }

      // Do not continue if event.key is missing
      if (!event.key) return;

      // Set up the event key.
      var eventKey = event.key === ' ' ? 'spacebar' : event.key.toLowerCase();

      // Create an object of event handlers based on the event key.
      var keydownHandlers = {
        backspace: _this.handleBackspaceKey,
        tab: _this.handleTabKey,
        enter: _this.handleEnterKey,
        escape: _this.handleEscapeKey,
        spacebar: _this.handleSpacebarKey,
        arrowup: function arrowup() {
          _this.focusPreviousOption();
          event.preventDefault();
        },
        arrowdown: function arrowdown() {
          _this.focusNextOption();
          event.preventDefault();
        },
        pageup: function pageup() {
          _this.focusPageUpOption();
          event.preventDefault();
        },
        pagedown: function pagedown() {
          _this.focusPageDownOption();
          event.preventDefault();
        },
        end: _this.handleEndKey,
        home: _this.handleHomeKey,
        "delete": _this.handleDeleteKey
      };

      // Get the KeyDownHandler by eventKey.
      var handler = keydownHandlers[eventKey];

      // If it matched, call the handler.
      if (handler) {
        handler(event);
      }
    });
    /* Start keydownHandlers */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleBackspaceKey", function (event) {
      if (!_this.state.inputValue && _this.props.backspaceRemoves) {
        _this.popValue();
        event.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTabKey", function (event) {
      if (event.shiftKey || !_this.state.isOpen || !_this.props.tabSelectsValue) {
        return;
      }
      _this.selectFocusedOption();
      event.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleEnterKey", function (event) {
      // If it's not open, open it
      if (!_this.state.isOpen) {
        _this.setState({
          isOpen: true
        });
        return;
      }
      // If it's open, update the value based on the curent selection...
      event.stopPropagation();
      if (_this.state.inputValue && _this.props.customInput && _this.props.customInput.test(_this.state.inputValue)) {
        _this.setCustomOption(_this.state.inputValue);
      } else {
        // ... and close it.
        _this.selectFocusedOption();
      }
      event.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleEscapeKey", function (event) {
      if (_this.state.isOpen) {
        _this.closeMenu();
        event.stopPropagation();
      } else if (_this.props.clearable && _this.props.escapeClearsValue) {
        _this.clearValue(event);
        event.stopPropagation();
      }
      event.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSpacebarKey", function (event) {
      // The editable/searchable variant should not perform an action
      // because it could be used for multi-word search.
      if (_this.props.searchable) {
        return;
      }

      // The following applies to the `select-only` variant:

      // If it's not open, open it
      if (!_this.state.isOpen) {
        _this.setState({
          isOpen: true
        });
        return;
      }

      // If it's open, update the value based on the curent selection and close it.
      _this.selectFocusedOption();
      event.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleEndKey", function (event) {
      if (event.shiftKey) {
        return;
      }
      _this.focusEndOption();
      event.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleHomeKey", function (event) {
      if (event.shiftKey) {
        return;
      }
      _this.focusStartOption();
      event.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDeleteKey", function (event) {
      if (!_this.state.inputValue && _this.props.deleteRemoves) {
        event.preventDefault();
        _this.popValue();
      }
    });
    /* End keydownHandlers */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleValueClick", function (option, event) {
      if (!_this.props.onValueClick) return;
      _this.props.onValueClick(option, event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMenuScroll", function (event) {
      if (!_this.props.onMenuScrollToBottom) return;
      var target = event.target;
      if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
        _this.props.onMenuScrollToBottom();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOptionLabel", function (op) {
      var optionLabel = op[_this.props.labelKey];
      return optionLabel;
    });
    /**
     * Turns a value into an array from the given options
     *
     * @param {String|Number|Array} value - the value of the select input
     * @param {Object} nextProps - optionally specify the nextProps so the returned
     * array uses the latest configuration
     * @returns {Array} the value of the select represented in an array
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getValueArray", function (value, nextProps) {
      /** support optionally passing in the `nextProps` so `componentWillReceiveProps`
       * updates will function as expected */
      var props = (0, _typeof2["default"])(nextProps) === 'object' ? nextProps : _this.props;
      var valueData = value;
      if (props.multi) {
        if (typeof valueData === 'string') valueData = valueData.split(props.delimiter);
        if (!Array.isArray(valueData)) {
          if (valueData === null || valueData === undefined) return [];
          valueData = [valueData];
        }
        return valueData.map(function (valueProp) {
          return _this.expandValue(valueProp, props);
        }).filter(function (i) {
          return i;
        });
      }
      var expandedValue = _this.expandValue(valueData, props);
      var resultExpandedValue = [];
      if (expandedValue) {
        resultExpandedValue.push(expandedValue);
      }
      return resultExpandedValue;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getInput", function () {
      var input = _this.input;
      if (input && typeof input.getInput === 'function') {
        // Get the actual DOM input if the ref is an <AutosizeInput /> component
        input = input.getInput();
      }
      return input;
    });
    /**
     * Retrieve a value from the given options and valueKey
     *
     * {String|Number|Array} value - the selected value(s)
     * {Object} props - the Select component's props (or nextProps)
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "expandValue", function (value, props) {
      var valueType = (0, _typeof2["default"])(value);
      if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') {
        return value;
      }
      var _props$options = props.options,
        options = _props$options === void 0 ? [] : _props$options,
        valueKey = props.valueKey;
      var extendedOptions = [].concat((0, _toConsumableArray2["default"])(options), (0, _toConsumableArray2["default"])(_this.state.customOptions));
      if (!extendedOptions) {
        return false;
      }
      for (var i = 0; i < extendedOptions.length; i += 1) {
        var localValue = extendedOptions[i][valueKey] || '';
        if (localValue.toString() === value) {
          return extendedOptions[i];
        }
      }
      return false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setValue", function (value) {
      var _this$props3 = _this.props,
        autoBlur = _this$props3.autoBlur,
        onChange = _this$props3.onChange,
        multi = _this$props3.multi,
        valueKey = _this$props3.valueKey,
        delimiter = _this$props3.delimiter;
      if (autoBlur) {
        _this.blurInput();
      }
      _this.setState({
        value: value
      });
      if (!onChange) return;

      // TODO: deprecate valueData, which returns an array of strings
      // and replace it with itemsSelected
      var valueData;
      if (multi) {
        valueData = value.map(function (item) {
          return item[valueKey];
        }).join(delimiter);
      } else {
        var optionValue = value && value[valueKey];
        var optionValueExists = optionValue !== null && optionValue !== undefined;
        valueData = optionValueExists ? optionValue.toString() : undefined;
      }
      onChange({
        value: valueData || '',
        itemsSelected: Array.isArray(value) ? (0, _toConsumableArray2["default"])(value) : _objectSpread({}, value)
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectValue", function (value) {
      // NOTE: update value in the callback to make sure the input value is empty so that
      // there are no styling issues (Chrome had issue otherwise)
      _this.hasScrolledToOption = false;
      if (_this.props.multi) {
        _this.setState({
          inputValue: '',
          focusedIndex: null
        }, function () {
          _this.addValue(value);
        });
      } else {
        _this.setState({
          isOpen: false,
          inputValue: '',
          isPseudoFocused: _this.state.isFocused
        }, function () {
          _this.setValue(value);
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addValue", function (value) {
      var valueArray = _this.getValueArray(_this.state.value);
      _this.setValue(valueArray.concat(value));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "popValue", function () {
      var valueArray = _this.getValueArray(_this.state.value);
      if (!valueArray.length) return;
      if (valueArray[valueArray.length - 1].clearableValue === false) return;
      _this.setValue(valueArray.slice(0, valueArray.length - 1));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeValue", function (value) {
      var valueKey = _this.props.valueKey;
      var valueArray = _this.getValueArray(_this.state.value);
      _this.setValue(valueArray.filter(function (i) {
        return i[valueKey] !== value[valueKey];
      }));
      _this.focus();
    });
    /**
     * Called when the user clicks on the clear value X button.
     * @param event
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearValue", function (event) {
      // if the event was triggered by a mousedown and not the primary
      // button, ignore it.
      if (!event) {
        return;
      }
      if (event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.setValue(_this.getResetValue());
      _this.setState({
        isOpen: false,
        inputValue: ''
      }, _this.focus);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getResetValue", function () {
      if (_this.props.resetValue !== undefined) {
        return _this.props.resetValue;
      }
      if (_this.props.multi) {
        return [];
      }
      return undefined;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusOption", function (option) {
      var newOptionFocused = _this.state.focusedOption !== option;
      if (newOptionFocused) {
        _this.setState({
          focusedOption: option
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusNextOption", function () {
      _this.focusAdjacentOption('next');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusPreviousOption", function () {
      _this.focusAdjacentOption('previous');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusPageUpOption", function () {
      _this.focusAdjacentOption('page_up');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusPageDownOption", function () {
      _this.focusAdjacentOption('page_down');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusStartOption", function () {
      _this.focusAdjacentOption('start');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusEndOption", function () {
      _this.focusAdjacentOption('end');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusAdjacentOption", function (dir) {
      var options = _this.visibleOptions.map(function (option, index) {
        return {
          option: option,
          index: index
        };
      }).filter(function (option) {
        return !option.option.disabled;
      });
      _this.scrollToFocusedOptionOnUpdate = true;
      if (!_this.state.isOpen) {
        _this.setState({
          isOpen: true,
          inputValue: '',
          focusedOption: _this.focusedOption || options[dir === 'next' ? 0 : options.length - 1].option
        });
        return;
      }
      if (!options.length) return;
      var focusedIndex = -1;
      for (var i = 0; i < options.length; i += 1) {
        if (_this.focusedOption === options[i].option) {
          focusedIndex = i;
          break;
        }
      }
      if (dir === 'next' && focusedIndex !== -1) {
        focusedIndex = (focusedIndex + 1) % options.length;
      } else if (dir === 'previous') {
        if (focusedIndex > 0) {
          focusedIndex -= 1;
        } else {
          focusedIndex = options.length - 1;
        }
      } else if (dir === 'start') {
        focusedIndex = 0;
      } else if (dir === 'end') {
        focusedIndex = options.length - 1;
      } else if (dir === 'page_up') {
        var potentialIndex = focusedIndex - _this.props.pageSize;
        if (potentialIndex < 0) {
          focusedIndex = 0;
        } else {
          focusedIndex = potentialIndex;
        }
      } else if (dir === 'page_down') {
        var _potentialIndex = focusedIndex + _this.props.pageSize;
        if (_potentialIndex > options.length - 1) {
          focusedIndex = options.length - 1;
        } else {
          focusedIndex = _potentialIndex;
        }
      }
      _this.setState({
        focusedIndex: options[focusedIndex].index,
        focusedOption: options[focusedIndex].option
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectFocusedOption", function () {
      if (_this.focusedOption) {
        return _this.selectValue(_this.focusedOption);
      }
      return false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderLoading", function () {
      if (_this.props.isLoading) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: _this.props.theme['select-loading-zone'],
          "data-test-id": _this.props.testId && "".concat(_this.props.testId, "-select-loading")
        }, _Spinner || (_Spinner = /*#__PURE__*/_react["default"].createElement(_Spinner2["default"], {
          "aria-hidden": "true",
          size: "s"
        })));
      }
      return false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderValue", function (valueArray, isOpen) {
      var renderLabel = _this.props.valueRenderer || _this.getOptionLabel;
      var ValueComponent = _this.props.valueComponent;
      var nothingSelected = !valueArray.length || valueArray.length === 1 && valueArray[0].length === 0;
      if (nothingSelected) {
        return !_this.state.inputValue ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _this.props.theme['select-placeholder']
        }, _this.props.placeholder) : null;
      }
      var onClick = _this.props.onValueClick ? _this.handleValueClick : null;
      if (_this.props.multi) {
        return valueArray.map(function (value, i) {
          var ValueComponentData = /*#__PURE__*/_react["default"].createElement(ValueComponent, {
            id: "".concat(_this.instancePrefix, "-value-").concat(i),
            instancePrefix: _this.instancePrefix,
            disabled: _this.props.disabled || value.clearableValue === false,
            key: "value-".concat(i, "-").concat(value[_this.props.valueKey]),
            onClick: onClick,
            onRemove: _this.removeValue,
            value: value,
            className: _this.props.theme['select-value'],
            classNameLabel: _this.props.theme['select-value-label'],
            classNameValueIcon: _this.props.theme['select-value-icon'],
            testId: _this.props.testId && "".concat(_this.props.testId, "-value"),
            "aria-labelledby": _this.props['aria-labelledby'],
            "aria-label": _this.props['aria-label']
          }, renderLabel(value, i), /*#__PURE__*/_react["default"].createElement("span", {
            className: _this.props.theme['select-aria-only']
          }, "\xA0"));
          return ValueComponentData;
        });
      } else if (!_this.state.inputValue) {
        if (isOpen) onClick = null;
        var valueClassNames = (0, _classnames["default"])(_this.props.theme['select-value'], (0, _defineProperty2["default"])({}, _this.props.theme['select-value-clearable'], _this.props.clearable));
        return /*#__PURE__*/_react["default"].createElement(ValueComponent, {
          id: "".concat(_this.instancePrefix, "-value-item"),
          disabled: _this.props.disabled,
          instancePrefix: _this.instancePrefix,
          onClick: onClick,
          value: valueArray[0],
          className: valueClassNames,
          classNameLabel: _this.props.theme['select-value-label'],
          testId: _this.props.testId && "".concat(_this.props.testId, "-value"),
          "aria-labelledby": _this.props['aria-labelledby'],
          "aria-label": _this.props['aria-label']
        }, renderLabel(valueArray[0]));
      }
      return false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderInput", function (valueArray, focusedOptionIndex) {
      var inlineClassName = _this.props.autosize ? '' : _this.props.theme['select-input-inline'];
      var className = (0, _classnames["default"])(_this.props.theme['select-input'], _this.props.theme[_this.props.inputProps.className], inlineClassName);
      var isOpen = !!_this.state.isOpen;
      var ariaOwns = (0, _classnames["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, "".concat(_this.instancePrefix, "-list"), isOpen), "".concat(_this.instancePrefix, "-backspace-remove-message"), _this.props.multi && !_this.props.disabled && _this.state.isFocused && !_this.state.inputValue));

      // TODO: Check how this project includes Object.assign()
      var tabIndexValue = '0';
      if (_this.props.disabled) {
        tabIndexValue = '-1';
      } else if (_this.props.tabindex) {
        tabIndexValue = _this.props.tabindex;
      }
      var inputName;
      if (_this.state.valueDefine && !_this.props.value || !_this.state.valueDefine && !_this.state.value || _this.props.multi && _this.state.valueDefine && !_this.props.value.length || _this.props.multi && !_this.state.valueDefine && !_this.state.value.length) {
        inputName = _this.props.name;
      } else {
        inputName = '';
      }
      var inputProps = (0, _extends2["default"])({}, _this.props.inputProps, {
        'id': _this.props.id,
        'role': 'combobox',
        'aria-expanded': "".concat(isOpen),
        'aria-owns': ariaOwns,
        'aria-haspopup': "".concat(isOpen),
        'aria-activedescendant': isOpen ? "".concat(_this.instancePrefix, "-option-").concat(focusedOptionIndex) : undefined,
        'aria-labelledby': _this.props['aria-labelledby'],
        'aria-label': _this.props['aria-label'],
        'className': className,
        'tabIndex': tabIndexValue,
        'onBlur': _this.props.onBlur,
        'onChange': _this.handleInputChange,
        'onFocus': _this.handleInputFocus,
        'value': _this.state.inputValue,
        // this is typically an empty string, the value input has the value
        'name': inputName,
        'autoComplete': 'off'
      });
      if (_this.props.inputRenderer) {
        return _this.props.inputRenderer(_objectSpread({
          ref: function ref(_ref2) {
            return _this.input = _ref2;
          }
        }, inputProps));
      }
      if (_this.props.disabled || !_this.props.searchable) {
        var _this$props$inputProp = _this.props.inputProps,
          inputClassName = _this$props$inputProp.inputClassName,
          divProps = (0, _objectWithoutProperties2["default"])(_this$props$inputProp, _excluded); // eslint-disable-line
        return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, divProps, {
          "aria-disabled": _this.props.disabled,
          id: _this.props.id,
          role: "combobox",
          "aria-expanded": isOpen,
          "aria-owns": isOpen ? "".concat(_this.instancePrefix, "-list") : "".concat(_this.instancePrefix, "-value"),
          "aria-activedescendant": isOpen ? "".concat(_this.instancePrefix, "-option-").concat(focusedOptionIndex) : "".concat(_this.instancePrefix, "-value"),
          className: className,
          tabIndex: tabIndexValue,
          onBlur: _this.props.onBlur,
          onFocus: _this.handleInputFocus,
          ref: function ref(_ref3) {
            return _this.input = _ref3;
          },
          "aria-readonly": !!_this.props.disabled,
          readOnly: true
        }));
      }
      if (_this.props.autosize) {
        return /*#__PURE__*/_react["default"].createElement(_reactInputAutosize["default"], (0, _extends2["default"])({
          "data-test-id": _this.props.testId && "".concat(_this.props.testId, "-filter-value")
        }, inputProps, {
          ref: function ref(_ref4) {
            return _this.input = _ref4;
          },
          minWidth: "5"
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
        "data-test-id": _this.props.testId && "".concat(_this.props.testId, "-filter-value")
      }, inputProps, {
        setRef: function setRef(ref) {
          return _this.input = ref;
        },
        onClick: function onClick() {
          return _this.setState({
            isOpen: true
          });
        }
      }));
    });
    /**
     * Renders the 'X' button that is used to quickly clear the select control value
     *
     * @return {XML | boolean} False if clear should not be rendered, the clear button
     * otherwise.
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderClear", function () {
      var _this$props4 = _this.props,
        multi = _this$props4.multi,
        testId = _this$props4.testId,
        disabled = _this$props4.disabled,
        isLoading = _this$props4.isLoading,
        clearable = _this$props4.clearable;
      var selectedValue = _this.propsOrState('value');

      // Render the clear element if
      // 1) Select is not disabled, is not loading and is clearable
      // 2) There is a value set in a single select
      // 3) There is a value set in a multi select
      var shouldRenderClearElement = !disabled && !isLoading && clearable && (!multi && selectedValue || multi && selectedValue && selectedValue.length);
      if (!shouldRenderClearElement) {
        return false;
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _this.props.theme['select-clear-zone']
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _this.props.theme['select-clear-wrapper']
      }, /*#__PURE__*/_react["default"].createElement("button", {
        "data-test-id": testId && "".concat(testId, "-select-clear-zone"),
        onClick: _this.clearValue,
        onTouchStart: _this.handleTouchStart,
        onTouchMove: _this.handleTouchMove,
        onTouchEnd: _this.handleTouchEndClearValue
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: _this.props.theme['select-clear'],
        name: "close-small",
        title: multi ? _this.props.clearAllText : _this.props.clearValueText,
        size: ""
      }))));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderArrow", function () {
      var onMouseDown = _this.handleMouseDownOnArrow;
      var theme = _this.props.theme;
      var testId = _this.props.testId;
      var arrow = _this.props.arrowRenderer({
        onMouseDown: onMouseDown,
        theme: theme
      });
      if (!_this.props.isLoading) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: theme['select-arrow-zone'],
          "data-test-id": testId && "".concat(testId, "-select-arrow-zone"),
          onMouseDown: onMouseDown
        }, arrow);
      }
      return false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "filterOptions", function (excludeOptions) {
      var filterValue = _this.state.inputValue;
      var options = _this.props.options || [];
      if (_this.props.filterOptions) {
        // Maintain backwards compatibility with boolean attribute
        var filterOptions = typeof _this.props.filterOptions === 'function' ? _this.props.filterOptions : _defaultFilterOptions["default"];
        return filterOptions(options, filterValue, excludeOptions, {
          filterOption: _this.props.filterOption,
          ignoreAccents: _this.props.ignoreAccents,
          ignoreCase: _this.props.ignoreCase,
          labelKey: _this.props.labelKey,
          matchPos: _this.props.matchPos,
          matchProp: _this.props.matchProp,
          valueKey: _this.props.valueKey,
          theme: _this.props.theme
        });
      }
      return options;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOptionRef", function (ref, isFocused) {
      if (isFocused && ref && ref.getBoundingClientRect) {
        _this.focused = ref;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderMenu", function (options, valueArray, focusedOption, testId) {
      if (options && options.length) {
        return _this.props.menuRenderer({
          focusedOption: focusedOption,
          focusOption: _this.focusOption,
          instancePrefix: _this.instancePrefix,
          labelKey: _this.props.labelKey,
          onFocus: _this.focusOption,
          onSelect: _this.selectValue,
          optionClassName: _this.props.optionClassName,
          optionComponent: _this.props.optionComponent,
          optionRenderer: _this.props.optionRenderer || _this.getOptionLabel,
          options: options,
          selectValue: _this.selectValue,
          valueArray: valueArray,
          valueKey: _this.props.valueKey,
          onOptionRef: _this.onOptionRef,
          testId: testId,
          theme: _this.props.theme
        });
      } else if (_this.props.noResultsText) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _this.props.theme['select-noresults'],
          "data-test-id": testId && "".concat(testId, "-no-result")
        }, _this.props.noResultsText);
      }
      return null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderHiddenField", function (valueArray) {
      if (!_this.props.name) return false;
      if (_this.props.joinValues) {
        var value = valueArray.map(function (i) {
          return (0, _stringifyValue["default"])(i[_this.props.valueKey]);
        }).join(_this.props.delimiter);
        var hiddenField = /*#__PURE__*/_react["default"].createElement("input", {
          type: "hidden",
          ref: function ref(_ref5) {
            return _this.value = _ref5;
          },
          name: _this.props.name,
          value: value,
          disabled: _this.props.disabled,
          required: _this.props.required
        });
        return hiddenField;
      }
      return valueArray.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement("input", {
          key: "hidden.".concat(index),
          type: "hidden",
          ref: "value".concat(index),
          name: _this.props.name,
          value: (0, _stringifyValue["default"])(item[_this.props.valueKey]),
          disabled: _this.props.disabled,
          required: _this.props.required
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getFocusableOptionIndex", function (selectedOption) {
      var options = _this.visibleOptions;
      if (!options.length) return null;
      var focusedOption = _this.state.focusedOption || selectedOption;
      if (focusedOption && !focusedOption.disabled) {
        var focusedOptionIndex = options.indexOf(focusedOption);
        if (focusedOptionIndex !== -1) {
          return focusedOptionIndex;
        }
      }
      for (var i = 0; i < options.length; i += 1) {
        if (!options[i].disabled) return i;
      }
      return null;
    });
    /**
     * Compare option and value.
     * @param {String|Number|Object} option
     * @param {String|Number|Object} value
     * @returns {Boolean} If the option and value are not null objects, then returns whether the objects' valueKey is equal.
     * Otherwise, returns whether option and value are equal as primitives.
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "areOptionAndValueEqual", function (option, value) {
      // compare as objects by value field
      if ((0, _typeof2["default"])(option) === 'object' && option !== null && (0, _typeof2["default"])(value) === 'object' && value !== null) {
        var valueKey = _this.props.valueKey;

        // verify that values are defined and equal
        var areValuesDefined = option[valueKey] && value[valueKey];
        var areValuesEqual = areValuesDefined && option[valueKey] === value[valueKey];
        return !!areValuesEqual;
      }

      // compare as primitives
      return option === value;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderOuter", function (options, valueArray, focusedOption, testId) {
      var header = _this.renderMenuHeader();
      var menu = _this.renderMenu(options, valueArray, focusedOption, testId);
      if (!menu && !header) {
        return null;
      }
      var composedClassName = (0, _classnames["default"])(_this.props.theme.selectMenuOuter, !_this.props.renderInBody && _this.props.theme.renderInComponent);
      var menuContainer = /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(_ref8) {
          return _this.menuContainer = _ref8;
        },
        className: composedClassName,
        style: _this.props.menuContainerStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(_ref6) {
          return _this.menu = _ref6;
        },
        role: "listbox",
        "data-test-id": _this.props.testId && "".concat(_this.props.testId, "-select-menu"),
        className: _this.props.theme['select-menu'],
        id: "".concat(_this.instancePrefix, "-list"),
        style: _this.props.menuStyle,
        onScroll: _this.handleMenuScroll,
        onMouseDown: _this.handleMouseDownOnMenu
      }, header, menu), _this.props.fixedActionComponent ? /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(_ref7) {
          return _this.fixedAction = _ref7;
        },
        className: _this.props.theme['fixed-action']
      }, _this.props.fixedActionComponent()) : null);
      var RenderInBodyMenuContainer = /*#__PURE__*/_react["default"].createElement(_RenderInBody["default"], {
        ref: function ref(_ref9) {
          return _this.portal = _ref9;
        }
      }, menuContainer);
      return _this.props.renderInBody ? RenderInBodyMenuContainer : menuContainer;
    });
    _this.state = {
      value: _this.props.value,
      inputValue: '',
      isFocused: false,
      isOpen: false,
      isPseudoFocused: false,
      focusedIndex: false,
      focusedOption: false,
      customOptions: []
    };
    _this.propsOrState = _propsOrState["default"].bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(Select, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.instancePrefix = "react-select-".concat(this.props.instanceId || (instanceId += 1), "-");
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autofocus) {
        this.focus();
      }
      document.addEventListener('mousedown', this.handleGlobalMouseDown, true);
    }

    // TODO: Move the logic out of this method.
    // * We are writing the same state logic in the constructor and here.
    // * It violates Reacts own recommendations, componentWillReceiveProps is
    //   flagged as unsafe by react.
    // * It opens us up to bugs with props and state since we are intercepting the
    //   lifecycle.
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var nextValue = nextProps.value;

      /**
       * Danger, Will Robinson: The select control is wrapped by the TypeAhead
       * control. That control can dynamically alter the set of options, and this
       * must be done without clearing the existing selection. For example, I may
       * have "Apple" selected, then type "Orange". In this case, we still want
       * to keep "Apple", even though it is no longer present in the options list.
       * This is what optionsListEnforced is for, and why we set it to true if
       * this control has an async query.
       */
      var optionsListEnforced = nextProps.optionsListEnforced;
      if (optionsListEnforced) {
        var selectedValue = nextProps.value !== undefined ? nextProps.value : this.state.value;
        var valueArray = this.getValueArray(selectedValue);
        var nextOptions = nextProps.options || [];
        if (nextOptions.length && valueArray.length) {
          var isValueValid = function isValueValid(value) {
            return nextOptions.some(function (option) {
              return _this2.areOptionAndValueEqual(option, value);
            });
          };
          var areAllValuesValid = valueArray.every(isValueValid);

          // Retain selection if new options contain all selected items
          if (areAllValuesValid) {
            nextValue = nextProps.multi ? valueArray : valueArray[0];
          } else {
            nextValue = undefined;
          }
        }
      }
      this.setState({
        value: nextValue
      });
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isOpen !== this.state.isOpen) {
        this.toggleTouchOutsideEvent(nextState.isOpen);
        var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
        if (handler) {
          handler();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.renderClear();
      // focus to the selected option
      if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
        this.menu.scrollTop = this.focused.offsetTop;
        this.hasScrolledToOption = true;
      } else if (!this.state.isOpen) {
        this.hasScrolledToOption = false;
      }
      if (this.scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
        this.scrollToFocusedOptionOnUpdate = false;
        var focusedRect = this.focused.getBoundingClientRect();
        var menuRect = this.menu.getBoundingClientRect();
        if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
          this.menu.scrollTop = this.focused.offsetTop + this.focused.clientHeight - this.focused.offsetHeight;
        }
      }
      if (prevProps.disabled !== this.props.disabled) {
        this.setState({
          isFocused: false
        }); // eslint-disable-line react/no-did-update-set-state
        this.closeMenu();
      }
      this.setMenuPosition();
      if (this.state.isOpen && this.menuContainer) {
        document.addEventListener('scroll', this.onScrollListener, true);
        window.addEventListener('resize', this.onResizeListener, true);
      } else {
        document.removeEventListener('scroll', this.onScrollListener, true);
        window.removeEventListener('resize', this.onResizeListener, true);
      }
      if (this.props.scrollMenuIntoView && this.menuContainer) {
        this.scrollMenuIntoView();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('touchstart', this.handleTouchOutside);
      document.removeEventListener('mousedown', this.handleGlobalMouseDown, true);
    }
  }, {
    key: "setMenuPosition",
    value: function setMenuPosition() {
      var _this3 = this;
      setTimeout(function () {
        if (!_this3.menuContainer || !_this3.control) {
          return;
        }
        var controlClientRect = _this3.control.getBoundingClientRect();
        var upwardsClasses = _this3.props.theme['select-menu-outer-upwards'];
        var upwardsClassesArray = upwardsClasses ? upwardsClasses.split(' ') : [];

        /**
         * Calculate vertical position for menuContainer
         * if menuContainer render in body we should consider in calculating controlClientRect.top
         * */
        var top = controlClientRect.height;
        if (_this3.props.renderInBody) top += controlClientRect.top;

        // Calculate vertical distance menuContainer from the window top
        var verticalDistance = controlClientRect.top + controlClientRect.height + _this3.menuContainer.offsetHeight;

        /**
         * If verticalDistance more then window height can happens that menuContainer
         * will not fit in window, so will be should add upwardsClassesArray class
         * and rendering menuContainer at the top of Select component
         * */
        if (verticalDistance > window.innerHeight) {
          var _this3$menuContainer$;
          (_this3$menuContainer$ = _this3.menuContainer.classList).add.apply(_this3$menuContainer$, (0, _toConsumableArray2["default"])(upwardsClassesArray));

          /**
           * Current top position should be 0 if menuContainer was rendered in component
           * because rendering position starting right after selectControl
           * */
          var currentTop = _this3.props.renderInBody ? controlClientRect.top : 0;
          top = currentTop - _this3.menuContainer.offsetHeight;
        } else {
          var _this3$menuContainer$2;
          (_this3$menuContainer$2 = _this3.menuContainer.classList).remove.apply(_this3$menuContainer$2, (0, _toConsumableArray2["default"])(upwardsClassesArray));
        }
        _this3.menuContainer.style.top = "".concat(top, "px");

        /**
         * Left position should be calculated only if menuContainer was rendered in body
         * because if menuContainer was rendered in component it has common wrapper with selectControl
         * and the same left position
         * */
        if (_this3.props.renderInBody) {
          _this3.menuContainer.style.left = "".concat(controlClientRect.left, "px");
        }

        /**
         * If autosizeMenu, menu will grow to fit its content (until it hits the edge of the viewport).
         * Otherwise, menu width is fixed to match the width of the field.
         * */
        if (_this3.props.autosizeMenu) {
          var maxWidth = window.innerWidth - controlClientRect.left - 10;
          _this3.menuContainer.style.maxWidth = "".concat(maxWidth, "px");
          _this3.menuContainer.style.minWidth = "".concat(controlClientRect.width, "px");
        } else {
          _this3.menuContainer.style.width = "".concat(controlClientRect.width, "px");
        }
      }, 0);
    }
  }, {
    key: "scrollMenuIntoView",
    value: function scrollMenuIntoView() {
      var _this4 = this;
      setTimeout(function () {
        if (!_this4.menuContainer) {
          return;
        }
        var menuContainerRect = _this4.menuContainer.getBoundingClientRect();
        if (window.innerHeight < menuContainerRect.bottom + _this4.props.menuBuffer) {
          window.scrollBy(0, menuContainerRect.bottom + _this4.props.menuBuffer - window.innerHeight);
        }
      }, 0);
    }
  }, {
    key: "renderMenuHeader",
    value: function renderMenuHeader() {
      var content;
      var isHint = false;
      var _this$props5 = this.props,
        customInput = _this$props5.customInput,
        dropdownHint = _this$props5.dropdownHint,
        theme = _this$props5.theme;
      var inputValue = this.state.inputValue;
      if (customInput && customInput.test(inputValue)) {
        content = "Hit enter to add \u201C".concat(inputValue, "\u201D");
      } else if (dropdownHint) {
        content = dropdownHint;
        isHint = true;
      }
      if (!content) {
        return null;
      }
      var hintClass = theme['select-menu-header-hint'];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(theme['select-menu-header'], (0, _defineProperty2["default"])({}, hintClass, isHint))
      }, content);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props6 = this.props,
        theme = _this$props6.theme,
        testId = _this$props6.testId,
        refCallback = _this$props6.refCallback;
      var valueArray = this.getValueArray(this.state.value);
      this.visibleOptions = this.filterOptions(this.props.multi ? valueArray : null);
      var options = this.visibleOptions;
      var isOpen = this.propsOrState('isOpen');
      if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) {
        isOpen = false;
      }
      var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
      var focusedOption = null;
      if (focusedOptionIndex !== null) {
        focusedOption = this.focusedOption = options[focusedOptionIndex];
      } else {
        focusedOption = this.focusedOption = null;
      }

      // Get classNames based on props and state.
      var selectClassesNamesPropsAndState = this.getClassNames();

      // Get classNames based on computed values.
      var selectClassesNamesComputed = (0, _classnames["default"])(isOpen && theme['is-open'], valueArray.length && theme['has-value']);

      // Combine classes from props and computed.
      var selectClasses = (0, _classnames["default"])(selectClassesNamesPropsAndState, selectClassesNamesComputed);
      var removeMessage = null;
      if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
        removeMessage = /*#__PURE__*/_react["default"].createElement("span", {
          "data-test-id": testId && "".concat(testId, "-select-remove-message"),
          id: "".concat(this.instancePrefix, "-backspace-remove-message"),
          className: this.props.theme['select-aria-only'],
          "aria-live": "assertive"
        }, this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey]));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: selectClasses,
        "data-test-id": testId,
        "data-anypoint-component": "Select",
        ref: function ref(node) {
          if (refCallback && typeof refCallback === 'function') {
            refCallback(node);
          }
          _this5.wrapper = node;
        },
        style: this.props.wrapperStyle
      }, this.renderHiddenField(valueArray), /*#__PURE__*/_react["default"].createElement("div", {
        // eslint-disable-line
        ref: function ref(_ref10) {
          return _this5.control = _ref10;
        },
        className: this.props.theme['select-control'],
        "data-test-id": testId && "".concat(testId, "-select-control"),
        style: this.props.style,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown,
        onTouchEnd: this.handleTouchEnd,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        onFocus: this.handleFocus
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: this.props.theme['select-multi-value-wrapper'],
        id: "".concat(this.instancePrefix, "-value")
      }, this.renderValue(valueArray, isOpen), this.renderInput(valueArray, focusedOptionIndex)), removeMessage, this.renderLoading(), this.renderClear(), this.renderArrow()), isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption, this.props.testId) : null);
    }
  }, {
    key: "getClassNames",
    value: function getClassNames() {
      var focusedStatus = typeof this.props.isFocused === 'undefined' ? this.state.isFocused : this.props.isFocused;
      return (0, _classnames["default"])(this.props.className, this.props.theme.select, this.props.multi ? this.props.theme['select--multi'] : this.props.theme['select--single'], this.props.multi && this.props.autosize && this.props.theme['select--multi-autosize'], this.props.disabled && this.props.theme['is-disabled'], this.props.isValid === true && this.props.theme['is-valid'], this.props.isValid === false && this.props.theme['has-error'], this.props.isDirty && this.props.theme['is-dirty'], this.props.searchable && this.props.theme['is-searchable'], this.props.size && this.props.theme["form-size-".concat(this.props.size)], this.state.isPseudoFocused && this.props.theme['is-pseudo-focused'], this.state.isFocused && this.props.theme['focus-select'], focusedStatus && this.props.theme['is-focused']);
    }
  }]);
  return Select;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Select, "defaultProps", defaultProps);
//# sourceMappingURL=Select.js.map